<template>
  <div>
    <div class="h-toolbarBg">
      <form id="gpsCall" @submit.prevent='banSubmit'>
        <div data-v-47d8ec93="" class="e-control e-toolbar e-lib e-keyboard" role="toolbar" aria-disabled="false" aria-haspopup="false" aria-orientation="horizontal" tabindex="0" style="height: auto; width: auto;">
          <div data-v-47d8ec93="" class="e-toolbar-items">
            <div data-v-47d8ec93="" aria-disabled="false" class="e-toolbar-item">
              <input :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model='locate.lng' :placeholder='$t("MCS.inputLng")' name='lng' width='180px'/>
            </div>
            <div data-v-47d8ec93="" aria-disabled="false" class="e-toolbar-item">
              <input :class="['e-control', 'e-textbox', 'e-lib', 'e-input']" v-model='locate.lat' :placeholder='$t("MCS.inputLat")' name='lat' width='180px'/>
            </div>
            <div data-v-47d8ec93="" aria-disabled="false" class="e-toolbar-item">
              <button :title='$t("MCS.locate")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='goLocate' data-ripple="true" tabindex="-1" style="width: auto;">
                <span class='e-btn-icon icon hero-icon hero-icon-locate e-icons'></span>
              </button>
            </div>
            <div class="e-toolbar-item e-separator" aria-disabled="false"></div>
            <div data-v-47d8ec93="" aria-disabled="false" class="e-toolbar-item">
              <button :title='modelName[modelIndex]' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='changeModel' data-ripple="true" tabindex="-1" style="width: auto;">
                <span :class='classButtonModel[modelIndex]'></span>
              </button>
            </div>
          </div>
        </div>
        <div style="height: 10px; width: 100%;">
          <div id="lngTip" style="float: left; width: 180px; margin-left: 15px"></div>
          <div id="latTip" style="float: left; width: 180px; margin-left: 8px"></div>
        </div>
      </form>
    </div>
    <GpsMap ref='gpsMap' :modelIndex='modelIndex' style="margin-top: 22px;width: 100%;margin-left: 0px"></GpsMap>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import GpsMap from './GpsMap';

export default {
  name: 'GpsGroupCallDialog',
  components: {
    GpsMap
  },
  data() {
    return {
      modelName: [this.$t('MCS.openDrawMode'), this.$t('MCS.closeDrawMode')],
      classButtonModel: [
        'e-btn-icon icon hero-icon hero-icon-off e-icons',
        'e-btn-icon icon hero-icon hero-icon-on e-icons'
      ],
      modelIndex: 0,
      locate: {
        lng: '',
        lat: ''
      },
      formObj: '',
      options: {
        validationComplete: function (args) {
          if (args.status === 'success') {
            //
          } else {
            //
          }
        },
        customPlacement: function(inputElement, errorElement) {
          if (inputElement.name === 'lng') {
            document.getElementById('lngTip').appendChild(errorElement);
          }
          if (inputElement.name === 'lat') {
            document.getElementById('latTip').appendChild(errorElement);
          }
        },
        rules: {
          'lng': {
            number: [true, this.$t('MCS.insertNum')],
            max: [180, this.$t('MCS.rangeLng')],
            min: [-180, this.$t('MCS.rangeLng')]
          },
          'lat': {
            number: [true, this.$t('MCS.insertNum')],
            max: [90, this.$t('MCS.rangeLat')],
            min: [-90, this.$t('MCS.rangeLat')],
          },
        }


      }
    };
  },
  methods: {
    changeModel() {
      this.modelIndex = 1 - this.modelIndex;
      this.$refs.gpsMap.changeModel();
    },
    goLocate() {
      if (this.locate.lng !== '' && this.locate.lat !== '' && this.locate.lng >= -180 && this.locate.lng <= 180 && this.locate.lat >= -90 && this.locate.lat <= 90) {
        this.$refs.gpsMap.goLocate(this.locate.lng, this.locate.lat);
      }
    },
    banSubmit() {
      return false;
    }
  },
  mounted() {
    document.getElementsByClassName('leaflet-control-zoom-in')[0].title = this.$t('MCS.zoomIn');
    document.getElementsByClassName('leaflet-control-zoom-out')[0].title = this.$t('MCS.zoomOut');
    this.formObj = new FormValidator('#gpsCall', this.options);
  },
}
</script>

<style scoped>

</style>
